import { string, ref } from 'yup';

const username = () => string().min(5);

const studentID = () => string().trim().min(5);

const email = () => string().trim().lowercase().email();

const password = () => string().min(8);

const passwordConfirm = () => string().oneOf([ref('password')], 'Both passwords need to be the same');

const mobileRegex = /^\d{8}$/;

const mobile = () => string().matches(mobileRegex);

export {
  username, email, password, passwordConfirm, studentID, mobile,
};
